import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  return (
    <div className="home-container">
      <section className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title">안전정보 통합 서비스</h1>
          <p className="hero-subtitle">울산 지역 실종자 정보와 재난문자를 확인할 수 있는 통합 서비스입니다.</p>
          <div className="hero-buttons">
            <Link to="/missing-persons" className="btn btn-primary">실종자 찾기</Link>
            <Link to="/disaster-messages" className="btn btn-secondary">재난문자 확인</Link>
          </div>
        </div>
      </section>

      <section className="features-section">
        <h2 className="section-title">제공 서비스</h2>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">
              <i className="fas fa-search"></i>
            </div>
            <h3 className="feature-title">실종자 정보</h3>
            <p className="feature-description">
              경찰청 안전Dream과 연계하여 울산 지역 실종자 정보를 제공합니다.
              가족을 찾고 있는 분들에게 도움이 되는 정보를 확인할 수 있습니다.
            </p>
            <Link to="/missing-persons" className="feature-link">자세히 보기</Link>
          </div>

          <div className="feature-card">
            <div className="feature-icon">
              <i className="fas fa-bell"></i>
            </div>
            <h3 className="feature-title">재난문자</h3>
            <p className="feature-description">
              행정안전부의 재난문자 서비스와 연계하여 재난 알림 정보를 제공합니다.
              자연재해, 사회재난, 민방위 경보 등 다양한 안전 정보를 확인할 수 있습니다.
            </p>
            <Link to="/disaster-messages" className="feature-link">자세히 보기</Link>
          </div>

          <div className="feature-card">
            <div className="feature-icon">
              <i className="fas fa-info-circle"></i>
            </div>
            <h3 className="feature-title">안전 정보</h3>
            <p className="feature-description">
              각종 안전 정보와 지침을 제공합니다. 재난 발생 시 행동요령,
              실종자 발견 시 신고 방법 등 유용한 정보를 확인할 수 있습니다.
            </p>
            <a href="https://www.safekorea.go.kr/idsiSFK/neo/main_m/main.html"
              target="_blank"
              rel="noopener noreferrer"
              className="feature-link">
              자세히 보기
            </a>
          </div>
        </div>
      </section>

      <section className="emergency-section">
        <h2 className="section-title">긴급 연락처</h2>
        <div className="emergency-cards">
          <div className="emergency-card">
            <div className="emergency-icon">
              <i className="fas fa-child"></i>
            </div>
            <h3 className="emergency-title">실종자 신고</h3>
            <p className="emergency-number">182</p>
            <p className="emergency-description">
              실종아동, 장애인, 치매노인 등의 실종신고와 발견 시 신고할 수 있습니다.
            </p>
          </div>

          <div className="emergency-card">
            <div className="emergency-icon">
              <i className="fas fa-shield-alt"></i>
            </div>
            <h3 className="emergency-title">경찰 신고</h3>
            <p className="emergency-number">112</p>
            <p className="emergency-description">
              각종 사건, 사고, 범죄 신고와 긴급 상황 시 신고할 수 있습니다.
            </p>
          </div>

          <div className="emergency-card">
            <div className="emergency-icon">
              <i className="fas fa-ambulance"></i>
            </div>
            <h3 className="emergency-title">화재 및 구급</h3>
            <p className="emergency-number">119</p>
            <p className="emergency-description">
              화재, 구조, 구급 등 재난 상황 발생 시 신고할 수 있습니다.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;